export default "__VITE_ASSET__oJs1dIE___"